import { createAction } from "@reduxjs/toolkit";
export const ApikeySuccess = createAction<Object>("Apikey/Success");

export const saveApiKey = (apiKey: string) => {
  return async function (dispatch) {
    dispatch(ApikeySuccess({ apiKey: apiKey }));
  };
};
